export let groupByDate = function(entries) {
	return entries.reduce((acc, entry) => {
		// ts → yyyy-mm-dd 形式に変換
		const date = new Date(entry.ts).toISOString().split("T")[0];
	
		if (!acc[date]) acc[date] = [];
		acc[date].push(entry);
	
		return acc;
	}, {});
}
export let groupByDateAsArray = function(entries) {
	const grouped = entries.reduce((acc, entry) => {
		const date = new Date(entry.ts).toISOString().split("T")[0]; // YYYY-MM-DD
		if (!acc[date]) acc[date] = [];
		acc[date].push(entry);
		return acc;
	}, {});
	
	// オブジェクト → 配列に変換して、日付の降順（最新順）にソート
	return Object.entries(grouped)
		.map(([date, items]) => ({ date, items }))
		.sort((a, b) => new Date(b.date) - new Date(a.date));
}
/**
 * entries: 
 *  - パターンA: [{ date: 'YYYY-MM-DD', items: [...] }, ...]
 *  - パターンB: [{ ts: 1710000000000, ... }, ...] を日付単位でまとめたい場合 → options.mode='flat'
 * options:
 *  - mode: 'grouped' | 'flat' 
 *      'grouped'（デフォ）: Aのように date ごとに items が既にまとまっている
 *      'flat'            : Bのようにバラのレコード（ts持ち）を日付ごとに束ねる
 *  - useLocalTime: boolean（既定: false＝UTCで切る）
 */
export function groupByYearMonthDay(entries, { mode = 'grouped', useLocalTime = false } = {}) {
	// 内部キー作成
	const toYMD = (dstrOrTs) => {
	if (typeof dstrOrTs === 'string') {
		const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dstrOrTs);
		if (!m) return null;
			return { y: +m[1], m: +m[2], d: +m[3] };
		} else {
			const dt = new Date(dstrOrTs);
			if (Number.isNaN(dt)) return null;
			if (useLocalTime) {
				return { y: dt.getFullYear(), m: dt.getMonth() + 1, d: dt.getDate() };
			} else {
				return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
			}
		}
	};

  // year → month → day の3段Mapで集約
  const yMap = new Map(); // y -> Map(m -> Map(d -> items[]))

	if (mode === 'grouped') {
		// 形式A: {date, items[]} が来る
		for (const entry of entries) {
			if (!entry?.date || !Array.isArray(entry.items)) continue;
			const key = toYMD(entry.date);
			if (!key) continue;
			if (!yMap.has(key.y)) yMap.set(key.y, new Map());
			const mMap = yMap.get(key.y);
			if (!mMap.has(key.m)) mMap.set(key.m, new Map());
			const dMap = mMap.get(key.m);
			if (!dMap.has(key.d)) dMap.set(key.d, []);
			dMap.get(key.d).push(...entry.items);
		}
	} else {
		// 形式B: バラのレコード群を日付単位へ
		for (const rec of entries) {
			const ts = rec?.ts;
			if (!ts) continue;
			const key = toYMD(ts);
			if (!key) continue;
			if (!yMap.has(key.y)) yMap.set(key.y, new Map());
			const mMap = yMap.get(key.y);
			if (!mMap.has(key.m)) mMap.set(key.m, new Map());
			const dMap = mMap.get(key.m);
			if (!dMap.has(key.d)) dMap.set(key.d, []);
			dMap.get(key.d).push(rec);
		}
	}

	// Map → 希望配列形式へ（year↓, month↓, day↓）
	const out = Array.from(yMap.entries())
	.sort((a, b) => b[0] - a[0])
	.map(([year, mMap]) => {
	  const months = Array.from(mMap.entries())
		.sort((a, b) => b[0] - a[0])
		.map(([month, dMap]) => {
		  const days = Array.from(dMap.entries())
			.sort((a, b) => b[0] - a[0])
			.map(([day, items]) => ({ day, items }));
		  return { month, days };
		});
	  return { year, months };
	});

	return out;
}
export let groupByMonth = function(src) {
	const yearMap = new Map(); // year -> Array<{month,date,data}>
	
	for (const entry of src) {
		if (!entry?.date || !Array.isArray(entry.items)) continue;
		// "YYYY-MM-DD" を安全に分解（Dateにしない方がタイムゾーン誤差が出ない）
		const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(entry.date);
		if (!m) continue;
		const year  = Number(m[1]);
		const month = Number(m[2]); // 1-12
		const day   = Number(m[3]); // 1-31
		
		if (!yearMap.has(year)) yearMap.set(year, []);
			yearMap.get(year).push({
			month,
			date: day,
			data: entry.items
		});
	}
	
	// 年↓, 月↓, 日↓で並び替えて出力
	const ymdata = Array.from(yearMap.entries())
		.sort((a, b) => b[0] - a[0])
		.map(([year, arr]) => ({
			year,
			data: arr.sort((a, b) => (b.month - a.month) || (b.date - a.date))
		}));
	
	return ymdata;
}